import { Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import RequireAuth from '../../components/RequireAuth';
import SocketProvider from '../../providers/socket.provider';
import UnitProvider from '../../providers/unit.provider';
import Header from '../Header';
import SideBar from '../SideBar';

export default function Layout() {
  return (
    <SocketProvider>
      <UnitProvider>
        <Container fluid className="ps-0">
          <Row className="flex-nowrap">
            <Col xs="auto">
              <SideBar />
            </Col>
            <Col>
              <Header />
              <Row className="justify-content-center">
                <Col xxl={10} xl={11}>
                  <RequireAuth>
                    <Outlet />
                  </RequireAuth>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </UnitProvider>
    </SocketProvider>
  );
}
